module.exports = __webpack_public_path__ + "static/img/activityChk.1e1ef04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activityChk.svg
// module id = hHxh
// module chunks = 1